"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildScryptTypeResolver = exports.buildTypeResolver = exports.buildTypeResolverFromDesc = exports.buildTypeClasses = exports.buildLibraryClass = exports.buildStructsClass = exports.buildContractClass = exports.AbstractContract = exports.SUPPORTED_MINIMUM_VERSION = exports.CURRENT_CONTRACT_DESCRIPTION_VERSION = void 0;
var _1 = require(".");
var compilerWrapper_1 = require("./compilerWrapper");
var internal_1 = require("./internal");
var scryptTypes_1 = require("./scryptTypes");
var path_1 = require("path");
exports.CURRENT_CONTRACT_DESCRIPTION_VERSION = 9;
exports.SUPPORTED_MINIMUM_VERSION = 8;
var AbstractContract = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    function AbstractContract() {
        var ctorParams = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            ctorParams[_i] = arguments[_i];
        }
        this.calls = new Map();
        this.hexTemplateInlineASM = new Map();
        this.hexTemplateArgs = new Map();
        this.statePropsArgs = [];
        // If true, the contract will read the state from property, if false, the contract will read the state from preimage
        // A newly constructed contract always has this set to true, and after invocation, always has it set to false
        this.firstCall = true;
    }
    Object.defineProperty(AbstractContract.prototype, "lockingScript", {
        get: function () {
            if (!this.dataPart) {
                return this.scriptedConstructor.lockingScript;
            }
            // append dataPart script to codePart if there is dataPart
            return this.codePart.add(this.dataPart);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractContract.prototype, "txContext", {
        get: function () {
            return this._txContext;
        },
        set: function (txContext) {
            this._txContext = txContext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractContract.prototype, "sourceMapFile", {
        get: function () {
            var desc = Object.getPrototypeOf(this).constructor.desc;
            return desc.sourceMapFile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractContract.prototype, "file", {
        get: function () {
            var desc = Object.getPrototypeOf(this).constructor.desc;
            return desc.file;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractContract.prototype, "contractName", {
        get: function () {
            var desc = Object.getPrototypeOf(this).constructor.desc;
            return desc.contract;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractContract.prototype, "stateProps", {
        get: function () {
            var desc = Object.getPrototypeOf(this).constructor.desc;
            return desc.stateProps || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractContract.prototype, "version", {
        get: function () {
            var desc = Object.getPrototypeOf(this).constructor.desc;
            return desc.version || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractContract.prototype, "resolver", {
        get: function () {
            return Object.getPrototypeOf(this).constructor.resolver;
        },
        enumerable: false,
        configurable: true
    });
    // replace assembly variables with assembly values
    AbstractContract.prototype.replaceAsmVars = function (asmVarValues) {
        if (asmVarValues) {
            for (var key in asmVarValues) {
                var val = asmVarValues[key];
                this.hexTemplateInlineASM.set("<" + (key.startsWith('$') ? key.substring(1) : key) + ">", internal_1.mvc.Script.fromASM(val).toHex());
            }
        }
        var hexTemplate = Object.getPrototypeOf(this).constructor.hex;
        var lockingScript = internal_1.buildContractCode(this.hexTemplateArgs, this.hexTemplateInlineASM, hexTemplate);
        this.scriptedConstructor.lockingScript = lockingScript;
    };
    Object.defineProperty(AbstractContract.prototype, "asmArgs", {
        // replace assembly variables with assembly values
        get: function () {
            var e_1, _a;
            var result = {};
            try {
                for (var _b = __values(this.hexTemplateInlineASM.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var entry = _c.value;
                    var name_1 = entry[0].replace('<', '').replace('>', '');
                    var value = entry[1];
                    result[name_1] = internal_1.mvc.Script.fromHex(value).toASM();
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return result;
        },
        enumerable: false,
        configurable: true
    });
    AbstractContract.prototype.getTypeClassByType = function (type) {
        return this.resolver.resolverClass(type);
    };
    /**
     * @param states an object. Each key of the object is the name of a state property, and each value is the value of the state property.
     * @returns a locking script that includes the new states. If you only provide some but not all state properties, other state properties are not modified when calculating the locking script.
     */
    AbstractContract.prototype.getNewStateScript = function (states) {
        var _this = this;
        var stateArgs = this.statePropsArgs;
        if (stateArgs.length === 0) {
            throw new Error("Contract " + this.contractName + " does not have any stateful property");
        }
        var resolveKeys = [];
        var newState = stateArgs.map(function (arg) {
            if (Object.prototype.hasOwnProperty.call(states, arg.name)) {
                resolveKeys.push(arg.name);
                var state = states[arg.name];
                var error = internal_1.checkSupportedParamType(state, arg, _this.resolver.resolverType);
                if (error) {
                    throw error;
                }
                return Object.assign(__assign({}, arg), {
                    value: states[arg.name]
                });
            }
            else {
                return arg;
            }
        });
        Object.keys(states).forEach(function (key) {
            if (resolveKeys.indexOf(key) === -1) {
                throw new Error("Contract " + _this.contractName + " does not have stateful property " + key);
            }
        });
        return this.codePart.add(internal_1.mvc.Script.fromHex(internal_1.buildContractState(newState, false, this.resolver.resolverType)));
    };
    AbstractContract.prototype.run_verify = function (unlockingScriptASM, txContext) {
        var txCtx = Object.assign({}, this._txContext || {}, txContext || {});
        var us = unlockingScriptASM.trim() ? internal_1.mvc.Script.fromASM(unlockingScriptASM.trim()) : new internal_1.mvc.Script();
        var ls = internal_1.mvc.Script.fromHex(this.lockingScript.toHex());
        var tx = txCtx.tx;
        var inputIndex = txCtx.inputIndex || 0;
        var inputSatoshis = txCtx.inputSatoshis || 0;
        internal_1.mvc.Script.Interpreter.MAX_SCRIPT_ELEMENT_SIZE = Number.MAX_SAFE_INTEGER;
        internal_1.mvc.Script.Interpreter.MAXIMUM_ELEMENT_SIZE = Number.MAX_SAFE_INTEGER;
        var bsi = internal_1.mvc.Script.Interpreter();
        var lastfExecs = {};
        bsi.stepListener = function (step) {
            if (step.fExec || (internal_1.mvc.Opcode.OP_IF <= step.opcode.toNumber() && step.opcode.toNumber() <= internal_1.mvc.Opcode.OP_ENDIF)) {
                if ((internal_1.mvc.Opcode.OP_IF <= step.opcode.toNumber() && step.opcode.toNumber() <= internal_1.mvc.Opcode.OP_ENDIF) || step.opcode.toNumber() === internal_1.mvc.Opcode.OP_RETURN) /**Opreturn */ {
                    lastfExecs.opcode = step.opcode;
                }
                else {
                    lastfExecs = step;
                }
            }
        };
        var result = bsi.verify(us, ls, tx, inputIndex, internal_1.DEFAULT_FLAGS, new internal_1.mvc.crypto.BN(inputSatoshis));
        if (result) {
            return {
                success: true,
                error: ''
            };
        }
        var failedOpCode = lastfExecs.opcode.toNumber();
        if ([internal_1.mvc.Opcode.OP_CHECKSIG, internal_1.mvc.Opcode.OP_CHECKSIGVERIFY, internal_1.mvc.Opcode.OP_CHECKMULTISIG, internal_1.mvc.Opcode.OP_CHECKMULTISIGVERIFY].includes(failedOpCode)) {
            if (!txCtx) {
                throw new Error('should provide txContext when verify');
            }
            if (!tx) {
                throw new Error('should provide txContext.tx when verify');
            }
        }
        var error = "VerifyError: " + bsi.errstr + ", fails at " + new internal_1.mvc.Opcode(failedOpCode) + "\n";
        if (this.sourceMapFile) {
            var sourceMapFilePath = internal_1.uri2path(this.sourceMapFile);
            var sourceMap = internal_1.JSONParserSync(sourceMapFilePath);
            var sourcePath = internal_1.uri2path(this.file);
            var srcDir_1 = path_1.dirname(sourcePath);
            var sourceFileName_1 = path_1.basename(sourcePath);
            var sources = sourceMap.sources.map(function (source) { return compilerWrapper_1.getFullFilePath(source, srcDir_1, sourceFileName_1); });
            var pos = internal_1.findSrcInfoV2(lastfExecs.pc, sourceMap);
            if (pos && sources[pos[1]]) {
                error = "VerifyError: " + bsi.errstr + " \n\t[Go to Source](" + internal_1.path2uri(sources[pos[1]]) + "#" + pos[2] + ")  fails at " + new internal_1.mvc.Opcode(failedOpCode) + "\n";
            }
        }
        else if (this.version === 8) {
            var desc = Object.getPrototypeOf(this).constructor.desc;
            var sourceMap = compilerWrapper_1.loadSourceMapfromDesc(desc);
            if (sourceMap.length > 0) {
                // the complete script may have op_return and data, but compiled output does not have it. So we need to make sure the index is in boundary.
                var opcodeIndex = lastfExecs.pc;
                if (sourceMap[opcodeIndex]) {
                    var opcode = sourceMap[opcodeIndex];
                    if (!opcode.pos || opcode.pos.file === 'std') {
                        var srcInfo = internal_1.findSrcInfoV1(sourceMap, opcodeIndex);
                        if (srcInfo) {
                            opcode.pos = srcInfo.pos;
                        }
                    }
                    // in vscode termianal need to use [:] to jump to file line, but here need to use [#] to jump to file line in output channel.
                    if (opcode && opcode.pos) {
                        error = "VerifyError: " + bsi.errstr + " \n\t[Go to Source](" + internal_1.path2uri(opcode.pos.file) + "#" + opcode.pos.line + ")  fails at " + new internal_1.mvc.Opcode(failedOpCode) + "\n";
                    }
                }
            }
        }
        return {
            success: result,
            error: error
        };
    };
    Object.defineProperty(AbstractContract.prototype, "dataPart", {
        get: function () {
            if (AbstractContract.isStateful(this)) {
                var state = internal_1.buildContractState(this.statePropsArgs, this.firstCall, this.resolver.resolverType);
                return internal_1.mvc.Script.fromHex(state);
            }
            if (this._dataPartInHex) {
                return internal_1.mvc.Script.fromHex(this._dataPartInHex);
            }
        },
        set: function (dataInScript) {
            throw new Error('Setter for dataPart is not available. Please use: setDataPart() instead');
        },
        enumerable: false,
        configurable: true
    });
    AbstractContract.prototype.setDataPart = function (state, isStateHex) {
        if (isStateHex === void 0) { isStateHex = false; }
        if (isStateHex == false) {
            console.warn('deprecated, using setDataPartInASM');
            this.setDataPartInASM(state);
        }
        else {
            console.warn('deprecated, using setDataPartInHex');
            this.setDataPartInHex(state);
        }
    };
    AbstractContract.prototype.setDataPartInASM = function (state) {
        if (AbstractContract.isStateful(this)) {
            throw new Error('should not use `setDataPartInASM` for a stateful contract, using `setDataPartInHex`');
        }
        var dataPartInASM = typeof state === 'string' ? state.trim() : internal_1.serializeState(state);
        this.setDataPartInHex(internal_1.mvc.Script.fromASM(dataPartInASM).toHex());
    };
    AbstractContract.prototype.setDataPartInHex = function (hex) {
        this._dataPartInHex = hex.trim();
        if (AbstractContract.isStateful(this)) {
            var _a = __read(_1.parseStateHex(this, this._dataPartInHex), 2), firstCall = _a[0], args = _a[1];
            this.statePropsArgs = args;
            this.firstCall = firstCall;
        }
    };
    Object.defineProperty(AbstractContract.prototype, "codePart", {
        get: function () {
            var lockingScript = this.scriptedConstructor.toScript();
            // note: do not trim the trailing space
            // 如果script有clone方法，这里可以直接clone
            if (lockingScript.hasOwnProperty('clone')) {
                return lockingScript.clone().add(internal_1.mvc.Script.fromHex('6a'));
            }
            var cloneScript = internal_1.mvc.Script.fromHex(lockingScript.toHex());
            cloneScript.add(internal_1.mvc.Script.fromHex('6a'));
            return cloneScript;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractContract.prototype, "codeHash", {
        get: function () {
            if (this.dataPart) {
                return internal_1.hash160(this.codePart.toHex());
            }
            else {
                return internal_1.hash160(this.lockingScript.toHex());
            }
        },
        enumerable: false,
        configurable: true
    });
    AbstractContract.getAsmVars = function (lockingScriptHex) {
        var instance = this.fromHex(lockingScriptHex);
        return instance.asmArgs;
    };
    AbstractContract.prototype.arguments = function (pubFuncName) {
        if (pubFuncName === 'constructor') {
            return this.scriptedConstructor.args;
        }
        if (this.calls.has(pubFuncName)) {
            return this.calls.get(pubFuncName).args;
        }
        return [];
    };
    AbstractContract.prototype.ctorArgs = function () {
        return this.arguments('constructor');
    };
    AbstractContract.fromASM = function (asm) {
        return null;
    };
    AbstractContract.fromHex = function (hex) {
        return null;
    };
    AbstractContract.fromTransaction = function (hex, outputIndex) {
        if (outputIndex === void 0) { outputIndex = 0; }
        return null;
    };
    AbstractContract.isStateful = function (contract) {
        return contract.stateProps.length > 0;
    };
    return AbstractContract;
}());
exports.AbstractContract = AbstractContract;
var invalidMethodName = ['arguments',
    'setDataPart',
    'setDataPartInASM',
    'setDataPartInHex',
    'version',
    'stateProps',
    'sourceMapFile',
    'file',
    'contractName',
    'ctorArgs',
    'run_verify',
    'replaceAsmVars',
    'asmVars',
    'asmArguments',
    'dataPart',
    'lockingScript',
    'codeHash',
    'codePart',
    'resolver',
    'getTypeClassByType',
    'getNewStateScript',
    'txContext'];
function buildContractClass(desc) {
    if (desc instanceof internal_1.CompileResult) {
        desc = desc.toDesc();
    }
    if (!desc.contract) {
        throw new Error('missing field `contract` in description');
    }
    if (!desc.version) {
        throw new Error('missing field `version` in description');
    }
    if (desc.version < exports.SUPPORTED_MINIMUM_VERSION) {
        throw new Error("Contract description version deprecated, The minimum version number currently supported is " + exports.SUPPORTED_MINIMUM_VERSION);
    }
    if (!desc.abi) {
        throw new Error('missing field `abi` in description');
    }
    if (!desc.hex) {
        throw new Error('missing field `hex` in description');
    }
    var ContractClass = /** @class */ (function (_super) {
        __extends(Contract, _super);
        function Contract() {
            var _a;
            var ctorParams = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                ctorParams[_i] = arguments[_i];
            }
            var _this = _super.call(this) || this;
            if (!Contract.asmContract) {
                _this.scriptedConstructor = (_a = Contract.abiCoder).encodeConstructorCall.apply(_a, __spread([_this, Contract.hex], ctorParams));
            }
            return _this;
        }
        //When create a contract instance using UTXO, 
        //use fromHex or fromASM because you do not know the parameters of constructor.
        /**
         * Create a contract instance using UTXO asm
         * @param hex
         */
        Contract.fromASM = function (asm) {
            return ContractClass.fromHex(internal_1.mvc.Script.fromASM(asm).toHex());
        };
        /**
         * Create a contract instance using UTXO hex
         * @param hex
         */
        Contract.fromHex = function (hex) {
            Contract.asmContract = true;
            var obj = new this();
            Contract.asmContract = false;
            obj.scriptedConstructor = Contract.abiCoder.encodeConstructorCallFromRawHex(obj, Contract.hex, hex);
            return obj;
        };
        /**
         * Create a contract instance using raw Transaction
         * @param hex
         */
        Contract.fromTransaction = function (hex, outputIndex) {
            if (outputIndex === void 0) { outputIndex = 0; }
            var tx = new internal_1.mvc.Transaction(hex);
            return ContractClass.fromHex(tx.outputs[outputIndex].script.toHex());
        };
        Object.defineProperty(Contract.prototype, "asmVars", {
            /**
             * Get the parameter of the constructor and inline asm vars,
             * all values is hex string, need convert it to number or bytes on using
             */
            get: function () {
                return ContractClass.getAsmVars(this.scriptedConstructor.toHex());
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Contract.prototype, "asmArguments", {
            get: function () {
                //TODO: @deprecate AbstractContract.getAsmVars , using asmArguments
                return null;
            },
            enumerable: false,
            configurable: true
        });
        return Contract;
    }(AbstractContract));
    ContractClass.desc = desc;
    ContractClass.resolver = buildScryptTypeResolver(desc);
    ContractClass.abi = desc.abi;
    ContractClass.hex = desc.hex;
    ContractClass.abiCoder = new internal_1.ABICoder(desc.abi, ContractClass.resolver);
    ContractClass.types = buildTypeClasses(desc);
    ContractClass.stateProps = desc.stateProps || [];
    ContractClass.abi.forEach(function (entity) {
        if (invalidMethodName.indexOf(entity.name) > -1) {
            throw new Error("Method name [" + entity.name + "] is used by scryptlib now, Pelease change you contract method name!");
        }
        ContractClass.prototype[entity.name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var call = ContractClass.abiCoder.encodePubFunctionCall(this, entity.name, args);
            this.calls.set(entity.name, call);
            return call;
        };
    });
    ContractClass.stateProps.forEach(function (p) {
        Object.defineProperty(ContractClass.prototype, p.name, {
            get: function () {
                var arg = this.statePropsArgs.find(function (arg) {
                    return arg.name === p.name;
                });
                if (arg) {
                    return arg.value;
                }
                else {
                    throw new Error("property " + p.name + " does not exists");
                }
            },
            set: function (value) {
                var arg = this.statePropsArgs.find(function (arg) {
                    return arg.name === p.name;
                });
                if (arg) {
                    arg.value = value;
                    this.firstCall = false;
                }
                else {
                    throw new Error("property " + p.name + " does not exists");
                }
            }
        });
    });
    return ContractClass;
}
exports.buildContractClass = buildContractClass;
/**
 * @deprecated use buildTypeClasses
 * @param desc CompileResult or ContractDescription
 */
function buildStructsClass(desc) {
    var structTypes = {};
    var structs = desc.structs || [];
    var finalTypeResolver = buildTypeResolverFromDesc(desc);
    structs.forEach(function (element) {
        var _a;
        var name = element.name;
        Object.assign(structTypes, (_a = {},
            _a[name] = /** @class */ (function (_super) {
                __extends(class_1, _super);
                function class_1(o) {
                    var _this = _super.call(this, o) || this;
                    _this._typeResolver = finalTypeResolver; //we should assign this before bind
                    _this.bind();
                    return _this;
                }
                return class_1;
            }(internal_1.Struct)),
            _a));
        structTypes[name].structAst = element;
    });
    return structTypes;
}
exports.buildStructsClass = buildStructsClass;
function buildStdLibraryClass() {
    var _a, _b;
    var libraryTypes = {};
    Object.assign(libraryTypes, (_a = {},
        _a['HashedMap'] = scryptTypes_1.HashedMap,
        _a));
    Object.assign(libraryTypes, (_b = {},
        _b['HashedSet'] = scryptTypes_1.HashedSet,
        _b));
    return libraryTypes;
}
function buildLibraryClass(desc) {
    var libraryTypes = {};
    // map LibraryEntity to StructEntity, as we treat library as struct
    var library = desc.library || [];
    var finalTypeResolver = buildTypeResolverFromDesc(desc);
    Object.assign(libraryTypes, buildStdLibraryClass());
    library.forEach(function (element) {
        var _a;
        var name = element.name;
        var libraryClass = /** @class */ (function (_super) {
            __extends(class_2, _super);
            function class_2() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, __spread(args)) || this;
                _this._typeResolver = finalTypeResolver; //we should assign this before bind
                _this.bind();
                return _this;
            }
            return class_2;
        }(scryptTypes_1.Library));
        libraryClass.libraryAst = element;
        Object.assign(libraryTypes, (_a = {},
            _a[name] = libraryClass,
            _a));
    });
    return libraryTypes;
}
exports.buildLibraryClass = buildLibraryClass;
function buildTypeClasses(desc) {
    if (Object.prototype.hasOwnProperty.call(desc, 'types')) {
        var CLASS = desc;
        return CLASS.types;
    }
    desc = desc;
    var structClasses = buildStructsClass(desc);
    var libraryClasses = buildLibraryClass(desc);
    var allTypeClasses = {};
    var alias = desc.alias || [];
    var resolver = buildTypeResolverFromDesc(desc);
    alias.forEach(function (element) {
        var _a, _b;
        var typeInfo = resolver(element.name);
        if (!internal_1.isArrayType(typeInfo.finalType)) { //not need to build class type for array, we only build class type for array element
            if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
                var type = internal_1.getNameByType(typeInfo.finalType);
                Object.assign(allTypeClasses, (_a = {},
                    _a[element.name] = /** @class */ (function (_super) {
                        __extends(class_3, _super);
                        function class_3(o) {
                            var _this = _super.call(this, o) || this;
                            _this._type = element.name;
                            _this._typeResolver = resolver;
                            return _this;
                        }
                        return class_3;
                    }(structClasses[type])),
                    _a));
            }
            else {
                var C = internal_1.BasicScryptType[typeInfo.finalType];
                if (C) {
                    var aliasClass = /** @class */ (function (_super) {
                        __extends(class_4, _super);
                        function class_4(o) {
                            var _this = _super.call(this, o) || this;
                            _this._type = element.name;
                            _this._typeResolver = resolver;
                            return _this;
                        }
                        return class_4;
                    }(C));
                    Object.assign(allTypeClasses, (_b = {},
                        _b[element.name] = aliasClass,
                        _b));
                }
                else {
                    throw new Error("can not resolve type alias " + element.name + " " + element.type);
                }
            }
        }
    });
    Object.assign(allTypeClasses, structClasses);
    Object.assign(allTypeClasses, libraryClasses);
    Object.assign(allTypeClasses, internal_1.BasicScryptType);
    return allTypeClasses;
}
exports.buildTypeClasses = buildTypeClasses;
function buildTypeResolverFromDesc(desc) {
    var alias = desc.alias || [];
    var library = desc.library || [];
    var structs = desc.structs || [];
    var contract = desc.contract;
    return buildTypeResolver(contract, alias, structs, library);
}
exports.buildTypeResolverFromDesc = buildTypeResolverFromDesc;
// build a resolver witch can only resolve type
function buildTypeResolver(contract, alias, structs, library, contracts, statics) {
    if (contracts === void 0) { contracts = []; }
    if (statics === void 0) { statics = []; }
    var resolvedTypes = {};
    structs.forEach(function (element) {
        resolvedTypes[element.name] = {
            finalType: element.name,
            symbolType: scryptTypes_1.SymbolType.Struct
        };
    });
    library.forEach(function (element) {
        resolvedTypes[element.name] = {
            finalType: element.name,
            symbolType: scryptTypes_1.SymbolType.Library
        };
    });
    contracts.forEach(function (element) {
        resolvedTypes[element.name] = {
            finalType: element.name,
            symbolType: scryptTypes_1.SymbolType.Contract
        };
    });
    // add std type
    resolvedTypes['HashedMap'] = {
        finalType: 'HashedMap',
        symbolType: scryptTypes_1.SymbolType.Library
    };
    resolvedTypes['HashedSet'] = {
        finalType: 'HashedSet',
        symbolType: scryptTypes_1.SymbolType.Library
    };
    resolvedTypes['SortedItem'] = {
        finalType: 'SortedItem',
        symbolType: scryptTypes_1.SymbolType.Struct
    };
    resolvedTypes['PubKeyHash'] = {
        finalType: 'Ripemd160',
        symbolType: scryptTypes_1.SymbolType.BaseType
    };
    alias.forEach(function (element) {
        resolvedTypes[element.name] = internal_1.resolveType(element.name, resolvedTypes, contract, statics, alias, library);
    });
    var resolver = function (type) {
        if (resolvedTypes[type]) {
            return resolvedTypes[type];
        }
        if (internal_1.BasicScryptType[type]) {
            return {
                finalType: type,
                symbolType: scryptTypes_1.SymbolType.BaseType
            };
        }
        return internal_1.resolveType(type, resolvedTypes, contract, statics, alias, library);
    };
    return resolver;
}
exports.buildTypeResolver = buildTypeResolver;
// build a resolver which can resolve type and ScryptType class
function buildScryptTypeResolver(desc) {
    var resolver = buildTypeResolverFromDesc(desc);
    var allTypes = buildTypeClasses(desc);
    return {
        resolverType: resolver,
        resolverClass: function (type) {
            var finalType = resolver(type).finalType;
            var typeName = internal_1.getNameByType(finalType) ? internal_1.getNameByType(finalType) : finalType;
            return allTypes[typeName];
        },
        allTypes: function () {
            return allTypes;
        }
    };
}
exports.buildScryptTypeResolver = buildScryptTypeResolver;
//# sourceMappingURL=contract.js.map